import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10b65c55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-customer-wrapper pr-6" }
const _hoisted_2 = { class: "flex align-items-center gap-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "LINE紐付け顧患者を表示", -1))
const _hoisted_4 = { class: "list-customer-body" }
const _hoisted_5 = { class: "flex flex-column gap-1" }
const _hoisted_6 = { class: "flex justify-content-center w-full" }
const _hoisted_7 = { key: 0 }

import { AxiosResponse } from "axios";
import { get, set } from "@vueuse/core";
import { computed, inject, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import Toast from "primevue/toast";
import InputSwitch from "primevue/inputswitch";
import { useToast } from "primevue/usetoast";
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "@/clinic/constants/router.constants";
import { CUSTOMER_ID_NAME_NAME_KANA_PHONE_PLACEHOLDER_SELECT } from "@/clinic/typings/constants/clinic";
import { CustomerServices } from "@/clinic/services";
import type {
  ApiBaseReq,
  ApiBaseReqParams,
  ApiBasePaginatorReq,
  ApiCustomerIndexRes,
  ICustomer,
} from "@/clinic/typings";
import { PageState } from "primevue/paginator";
import Header from "@/clinic/components/atoms/Grid/header.vue";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import RightSideBar from "../rightSidebar/RightSideBar.vue";
import { DEFAULT_MEDIUM_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import { CustomerStatusesConstants } from "@/clinic/constants/customer.constants";
import { CustomerFilterLineBy } from "@/clinic/typings/enums/customer";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

type IColumn = {
  field: string;
  header: string;
  class?: string;
  style?: string;
  icon?: any;
};

enum LineLinkedClassEnum {
  true = "icon-lms icon-lms_link text-line-green mx-auto",
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const toast = useToast();
const store = useStore();

const first = ref(0);
const searchTerm = ref("");
const rows = ref(DEFAULT_MEDIUM_PAGINATOR_ROWS);
const totalCount = ref(0);
const page = ref(0);
const pgTop = ref<InstanceType<typeof Paginator> | null>(null);
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);
const clinicId = ref(0);
const customers = ref<ICustomer[]>([]);
const currentUser = ref<ICustomer>({} as ICustomer);
const visibleSideBar = ref(false);
const sidebar = ref<InstanceType<typeof RightSideBar> | null>(null);
const loading = ref(false);
const filterLineBy = ref(false);
const totalCustomers = ref(0);
const totalLineCustomers = ref(0);

const formatNumber = (value: number) => new Intl.NumberFormat("ja-JP").format(value);

const onShowSidebar = async () => {
  await get(sidebar)?.onShow();
};

const onSwitchFilterLine = async () => {
  set(page, 0);
  set(first, 0); // firstプロパティもリセット
  await loadCustomers();
};

const enableHeaderButtons = () => {
  return store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated;
};

const columns = ref<IColumn[]>([
  { field: "code", header: "カルテNo.", class: "col-fixed", style: "width: 108px" },
  {
    field: "linked_line",
    header: "LINE紐付け",
    class: "col-fixed",
    style: "width: 85px; white-space:nowrap",
    icon: LineLinkedClassEnum,
  },
  { field: "status", header: "顧客ステータス", class: "col-fixed", style: "width: 110px; white-space:nowrap" },
  { field: "name", header: "名前", class: "col-2" },
  { field: "phone", header: "電話番号", class: "col-2" },
  { field: "address", header: "住所" },
  { field: "comment", header: "メモ" },
]);

const clinicIdParams = async (): Promise<ApiBaseReq> => ({ clinic_id: get(await get(clinicId)) });

const paginatorParams = computed(
  (): ApiBasePaginatorReq => ({ term: get(searchTerm), page: get(page) + 1, rows: get(rows) } as ApiBasePaginatorReq)
);

const paging = async (fromId: string, { page: newPage }: PageState) => {
  if (newPage === page.value) return;
  set(page, newPage);
  // firstプロパティを更新
  const newFirst = newPage * get(rows);
  set(first, newFirst);

  // ページ番号を1ベースに変換してAPIに送信
  const apiPage = newPage + 1;
  await loadCustomers(apiPage);
};

const onItemClick = async (event: any, item: any) => {
  await set(currentUser, item);
  await onShowSidebar();
};

const movetoNewCustomer = () => RouterUtils.goTo(RouterConstants.CUSTOMER_CREATE_ROUTER_NAME);

const loadCustomers = async (apiPage?: number) => {
  set(loading, true);
  const { data } = (await CustomerServices.getCustomers(
    {
      ...(await clinicIdParams()),
      term: get(searchTerm),
      page: apiPage || get(page) + 1, // APIには1ベースのページ番号を送信
      rows: get(rows),
      filter_line_by: get(filterLineBy) ? CustomerFilterLineBy.linked : CustomerFilterLineBy.all,
      show_total: true,
    } as ApiBaseReqParams,
    () => undefined,
    () => undefined
  )) as unknown as AxiosResponse<ApiCustomerIndexRes>;
  const { customers: customersData, meta, total_customers, total_line_customers } = get(data);
  set(totalCustomers, get(total_customers));
  set(totalLineCustomers, get(total_line_customers));
  const { total_count } = meta;
  set(
    customers,
    get(customersData).map(cus => {
      return {
        ...cus,
        address: `${cus.address || ""} ${cus.address_number || ""}`,
        linked_line: (cus?.line_account_ids || []).length != 0,
      } as unknown as ICustomer;
    })
  );
  set(totalCount, get(total_count));
  set(loading, false);
};

const onSearch = async ({ currentTarget }: Event) => {
  set(searchTerm, currentTarget?.value);
  if (page.value !== 0) {
    set(page, 0);
    set(first, 0); // firstプロパティもリセット
    await loadCustomers();
  } else {
    await loadCustomers();
  }
};

const handleImport = (event, inputImportFile) => {
  const button = event.currentTarget;
  button.classList.add("p-disabled");
  inputImportFile.value.click();
};

const fileChange = async (event, importButton, uploadFileCsv) => {
  const button = importButton.value.$el;

  await CustomerServices.importCustomers(
    get(await get(clinicId)),
    uploadFileCsv.value.files[0],
    () => {
      loadCustomers();
      notifySuccessMsg(toast, "顧客は正常にインポートされました");
    },
    () => {
      notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
    }
  );

  button.classList.remove("p-disabled");
};

const handleExport = async event => {
  const button = event.currentTarget;
  button.classList.add("p-disabled");

  const { data } = await CustomerServices.exportCustomers({
    ...(await clinicIdParams()),
    ...get(paginatorParams),
  } as ApiBaseReqParams);

  window.open(data.value, "_blank");
  button.classList.remove("p-disabled");
};

const loadList = async () => {
  set(clinicId, await inject("clinicId"));
  await loadCustomers();
};

onBeforeMount(() => loadList());

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RightSideBar, {
      ref_key: "sidebar",
      ref: sidebar,
      visible: visibleSideBar.value,
      "customer-id": currentUser.value.id || 0,
      "account-id": 0,
      "clinic-id": _unref(get)(clinicId.value)
    }, null, 8, ["visible", "customer-id", "clinic-id"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header, {
        enableSearch: "",
        onSearch: onSearch,
        searchValue: searchTerm.value,
        onNew: movetoNewCustomer,
        createButtonLabel: "顧客新規作成",
        enableCreate: enableHeaderButtons(),
        searchPlaceholder: _unref(CUSTOMER_ID_NAME_NAME_KANA_PHONE_PLACEHOLDER_SELECT),
        enableImport: false,
        onImport: handleImport,
        onFileChange: fileChange,
        enableExport: false,
        onExport: handleExport
      }, {
        otherSearchButtons: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(InputSwitch), {
              modelValue: filterLineBy.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterLineBy).value = $event)),
              onClick: onSwitchFilterLine
            }, null, 8, ["modelValue"]),
            _hoisted_3
          ])
        ]),
        otherButtons: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "顧客を統合",
            class: "mr-0 btn-orange",
            onClick: _cache[1] || (_cache[1] = () => _unref(RouterUtils).goTo(_unref(RouterConstants).DUPLICATE_CUSTOMERS_ROUTE_NAME))
          })
        ]),
        _: 1
      }, 8, ["searchValue", "enableCreate", "searchPlaceholder"]),
      _createElementVNode("div", _hoisted_4, [
        (totalCount.value > rows.value)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              id: "pg-top",
              ref_key: "pgTop",
              ref: pgTop,
              modelValue: first.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((first).value = $event)),
              onPaging: paging,
              totalRecords: totalCount.value,
              rows: rows.value
            }, null, 8, ["modelValue", "totalRecords", "rows"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, "※登録ユーザー数: " + _toDisplayString(formatNumber(totalCustomers.value)) + "人", 1),
          _createElementVNode("span", null, "※LINE紐づけユーザー数: " + _toDisplayString(formatNumber(totalLineCustomers.value)) + "人", 1)
        ]),
        _createVNode(Grid, {
          items: customers.value,
          columns: columns.value,
          loading: loading.value,
          onOnItemClick: onItemClick
        }, {
          status: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                class: _normalizeClass(["inline-block customer-status border-round-xl text-center mr-1 px-2", data.status])
              }, _toDisplayString(data.status_display_name || _unref(CustomerStatusesConstants)[data.status]), 3)
            ])
          ]),
          comment: _withCtx(({ data }) => [
            (data.comments_attributes.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(data.comments_attributes[0].content), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["items", "columns", "loading"]),
        (totalCount.value > rows.value)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 1,
              id: "pg-bot",
              ref_key: "pgBot",
              ref: pgBot,
              modelValue: first.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((first).value = $event)),
              onPaging: paging,
              totalRecords: totalCount.value,
              rows: rows.value,
              class: "mt-2"
            }, null, 8, ["modelValue", "totalRecords", "rows"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(Toast), { position: "top-center" })
      ])
    ])
  ], 64))
}
}

})